import React from 'react';
import "../../../styles/globalStyles.css";

export default function WelcomePage() {
  return (
    <section id="shop" className="sectionContainer light">
      <div className="sectionTitle">
        <h2>Witamy w naszym sklepie!</h2>
      </div>
      <div className="buttonSection">
        <div className="backButtonContainer">
          <button className="backButton" onClick={() => window.history.back()}>
            Powrót
          </button>
        </div>
      </div>
    </section>
  );
}